module.exports = __webpack_public_path__ + "images/embed/filetypes/page_white_office.png";